import React from "react"

const ToolboxIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="108" height="108" viewBox="0 0 108 108">
    <path fill="#009F6F" fillRule="evenodd" d="M80.988 3.34L83.63.28l.677-.28 2.316.175.626.378 20.107 32.046.645.504v39.176l-.616.788-63.116 15.736-.243.023-2.814-.161-.137-.146L1.41 78.753c-.778-.501-.913-.357-1.41-1.797V39.352l.197-.53L19.694 16.22l.677-.28 2.315.176.627.378.665 1.06L80.988 3.34zM44.032 49.686l.033.115v37.093l-.146.299.076.004 62.38-15.553V34.143L44.032 49.686zm-11.27-18.13l10.454 16.66 20.719-5.165V23.696l-31.172 7.858-.001.002zm32.201-9.639l6.704-7.77L28.58 24.888l3.275 5.22L64.814 21.8l.15.116-.001.001zm-40.076-2.914l2.785 4.438L85.55 9.01l2.263-2.274-2.172-2.882-60.755 15.148.001.001z"/>
</svg>

);

export default ToolboxIcon;